export default __webpack_public_path__ + "static/media/crion.6d3635bb.jpg";